import type { Planet } from "../sim/types";
import type { Renderer } from "./renderer";

/** tiles.wgsl flag: procedural solid-disc fill (ignores the atlas). */
const FLAG_PLANET_DISC = 2048;

/** Draws the planet as a single solid-surface disc. The fragment shader fills
 *  a circle inside the quad, so we just size the quad to the diameter. */
export function pushPlanetTile(r: Renderer, planet: Planet): void {
  const d = planet.radiusM * 2;
  r.pushTileRaw(
    planet.pos.x, planet.pos.y,
    d, d,
    0, FLAG_PLANET_DISC,
    0, 0, 0, 0,
    0, 0, 1,
    0, 0, 0,
  );
}
